module.exports = __webpack_public_path__ + "img/43-9ZA.4bb5f07.png";